//
//
//
//
//
//
//

export default {
  type: 'component',
  externalClasses: ['custom-class'],
  props: {
    type: {
      type: String,
      default: "page"
    },
    text: {
      type: String,
      default: "请求失败，请刷新重试"
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/app/error-view/index.vue